import { render, staticRenderFns } from "./WhatsAppLocationMessage.vue?vue&type=template&id=8927eec2&"
import script from "./WhatsAppLocationMessage.vue?vue&type=script&lang=js&"
export * from "./WhatsAppLocationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports